export default __webpack_public_path__ + "static/media/37.395cec71.jpeg";